
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EventsInterface } from '@/services/Calendar/Events/Interfaces';
import EventsRepository from '@/services/Calendar/Events';

@Component({
  inject: [
    'eventsRepository',
  ],
})
export default class DeleteEventDialog extends Vue {
  private readonly eventsRepository!: EventsRepository;

  @Prop() private readonly event!: EventsInterface;

  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete '${this.event.name}'?`;
  }

  private async deleteEvent(): Promise<void> {
    try {
      await this.eventsRepository.deleteEvent(this.event.id);
      this.$successDialog.show(`National event '${this.event.name}' has been deleted.`);
      this.$emit('deleted-event', this.event.id);
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
